export default __webpack_public_path__ + "static/media/trr-drink-specialty-rosegold.40614850.png";